// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 18) return "static/js/21e26b164e8a2291da1a.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"096e2cfeaac120b12688","122":"6d13e7abfa86cc8c8682","123":"558b29cff1fe7b08de59"}[chunkId] + ".chunk.js";
};